import { render } from "./EditCasePage.vue?vue&type=template&id=50e43c25&ts=true"
import script from "./EditCasePage.vue?vue&type=script&lang=ts"
export * from "./EditCasePage.vue?vue&type=script&lang=ts"

import "./EditCasePage.vue?vue&type=style&index=0&id=50e43c25&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__